export const TABLE_UPDATE = "BACKOFFICE_PAYMENT_LOCATIONS/TABLE_UPDATE";
export const FETCH_SUCCESS = "BACKOFFICE_PAYMENT_LOCATIONS/FETCH_SUCCESS";

const types = {
    DESTROY_FAILED: "BACKOFFICE_PAYMENT_LOCATIONS/DESTROY_FAILED",
    DESTROY_REQUEST: "BACKOFFICE_PAYMENT_LOCATIONS/DESTROY_REQUEST",
    DESTROY_SUCCESS: "BACKOFFICE_PAYMENT_LOCATIONS/DESTROY_SUCCESS",

    FETCH_FAILED: "BACKOFFICE_PAYMENT_LOCATIONS/FETCH_FAILED",
    FETCH_REQUEST: "BACKOFFICE_PAYMENT_LOCATIONS/FETCH_REQUEST",
    FETCH_SUCCESS,

    GET_FAILED: "BACKOFFICE_PAYMENT_LOCATIONS/GET_FAILED",
    GET_REQUEST: "BACKOFFICE_PAYMENT_LOCATIONS/GET_REQUEST",
    GET_SUCCESS: "BACKOFFICE_PAYMENT_LOCATIONS/GET_SUCCESS",

    PATCH_FAILED: "BACKOFFICE_PAYMENT_LOCATIONS/PATCH_FAILED",
    PATCH_REQUEST: "BACKOFFICE_PAYMENT_LOCATIONS/PATCH_REQUEST",
    PATCH_SUCCESS: "BACKOFFICE_PAYMENT_LOCATIONS/PATCH_SUCCESS",

    STORE_FAILED: "BACKOFFICE_PAYMENT_LOCATIONS/STORE_FAILED",
    STORE_REQUEST: "BACKOFFICE_PAYMENT_LOCATIONS/STORE_REQUEST",
    STORE_SUCCESS: "BACKOFFICE_PAYMENT_LOCATIONS/STORE_SUCCESS",

    UPDATE_FAILED: "BACKOFFICE_PAYMENT_LOCATIONS/UPDATE_FAILED",
    UPDATE_REQUEST: "BACKOFFICE_PAYMENT_LOCATIONS/UPDATE_REQUEST",
    UPDATE_SUCCESS: "BACKOFFICE_PAYMENT_LOCATIONS/UPDATE_SUCCESS",
    TABLE_UPDATE,
};

export default types;
